import IconHelp from '@mui/icons-material/HelpOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Button } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { Box } from '@mui/system'
import { useCallback } from 'react'

import { useHelpDrawer } from '../../context/ui/useHelpDrawer'

type HelpButtonProps = {
  buttonLabel?: string
  buttonSx?: object
  style?: unknown
  title: string
  text: React.ReactNode
  version?: string
  dense?: boolean
  isInfo?: boolean
}

export const HelpButton = ({ title, style, buttonLabel, text, version, dense, buttonSx, isInfo }: HelpButtonProps) => {
  const showHelpDrawer = useHelpDrawer()

  const onClick = useCallback(() => {
    showHelpDrawer(title, text, buttonLabel)
  }, [showHelpDrawer, title, text, buttonLabel])
  if (version === 'text') {
    return (
      <Box
        tabIndex={0}
        onClick={onClick}
        sx={{
          display: 'inline-block',
          '&:focus': { cursor: 'pointer', textDecoration: 'underline' },
          '&:hover': { cursor: 'pointer', textDecoration: 'underline' },
        }}
      >
        Click for more information ({title})
      </Box>
    )
  }
  if (version === 'button') {
    return (
      <Button
        variant="contained"
        color="inherit"
        title={title}
        onClick={onClick}
        sx={{ pl: 1, pr: 1, minWidth: 20 }}
        aria-label={`Click for more information (${title})`}
      >
        {isInfo ? <InfoOutlinedIcon /> : <IconHelp />}
      </Button>
    )
  }

  const iconButtonSx = { ...buttonSx, ...(dense ? { mt: -1, mb: -0.7, pb: '8px' } : {}) }

  return (
    <IconButton
      title={title}
      onClick={onClick}
      style={style || {}}
      aria-label={`Click for more information (${title})`}
      sx={iconButtonSx}
    >
      {isInfo ? <InfoOutlinedIcon /> : <IconHelp />}
    </IconButton>
  )
}
